module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-tokai-2-ca648d3bc4bda79f3bb34418d677bff4.png";